
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-file_bucket",
  "use": "icon-rescls-file_bucket-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-file_bucket\"><path fill=\"#3498db\" d=\"m8.689 4.349-.668-.984A.83.83 0 0 0 7.34 3H2.864a.845.845 0 0 0-.833.858l-.031 3h19.969L22 5.57a.845.845 0 0 0-.832-.857H9.37a.82.82 0 0 1-.681-.365z\" /><path fill=\"#68ace0\" d=\"M2 8.143h20v12a.845.845 0 0 1-.834.857H2.834A.845.845 0 0 1 2 20.142Z\" /><path fill=\"#fff\" d=\"M5.75 13.286h2.5a.634.634 0 0 0 .625-.643V12a.634.634 0 0 0-.625-.643h-2.5a.634.634 0 0 0-.625.643v.643c0 .355.28.643.625.643\" /><path fill=\"#fff\" d=\"M7.625 15.214h2.5a.634.634 0 0 0 .625-.643v-.642a.634.634 0 0 0-.625-.643h-2.5a.634.634 0 0 0-.625.643v.642c0 .355.28.643.625.643\" /><path fill=\"#fff\" d=\"M5.75 17.143h2.5a.634.634 0 0 0 .625-.643v-.643a.634.634 0 0 0-.625-.643h-2.5a.634.634 0 0 0-.625.643v.643c0 .355.28.643.625.643m0 3.857h2.5a.634.634 0 0 0 .625-.643v-.643a.634.634 0 0 0-.625-.643h-2.5a.634.634 0 0 0-.625.643v.643c0 .355.28.643.625.643\" /><path fill=\"#fff\" d=\"M7.625 19.071h2.5a.634.634 0 0 0 .625-.642v-.643a.634.634 0 0 0-.625-.643h-2.5a.634.634 0 0 0-.625.643v.643c0 .354.28.642.625.642\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-file_bucket"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-file_bucket";

        export default Icon;
    